/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptInviteResponse
} from './model/acceptInviteResponse.js';

import type {
  AcceptPendingInvites200
} from './model/acceptPendingInvites200.js';

import type {
  DeclineInvite200
} from './model/declineInvite200.js';

import type {
  GetInviteLanding200
} from './model/getInviteLanding200.js';

import type {
  ListPendingInvites200
} from './model/listPendingInvites200.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Accept one organization invite
 */
export const acceptInvite = (
    inviteId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AcceptInviteResponse>(
      {url: `/invites/${encodeURIComponent(String(inviteId))}/accept`, method: 'POST', signal
    },
      options);
    }




export const getAcceptInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvite>>, TError,{inviteId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptInvite>>, TError,{inviteId: string}, TContext> => {

const mutationKey = ['acceptInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptInvite>>, {inviteId: string}> = (props) => {
          const {inviteId} = props ?? {};

          return  acceptInvite(inviteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptInviteMutationResult = NonNullable<Awaited<ReturnType<typeof acceptInvite>>>

    export type AcceptInviteMutationError = unknown

    /**
 * @summary Accept one organization invite
 */
export const useAcceptInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvite>>, TError,{inviteId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof acceptInvite>>,
        TError,
        {inviteId: string},
        TContext
      > => {
      return useMutation(getAcceptInviteMutationOptions(options));
    }
    /**
 * @summary Decline an organization invite
 */
export const declineInvite = (
    inviteId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<DeclineInvite200>(
      {url: `/invites/${encodeURIComponent(String(inviteId))}/decline`, method: 'POST', signal
    },
      options);
    }




export const getDeclineInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineInvite>>, TError,{inviteId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof declineInvite>>, TError,{inviteId: string}, TContext> => {

const mutationKey = ['declineInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineInvite>>, {inviteId: string}> = (props) => {
          const {inviteId} = props ?? {};

          return  declineInvite(inviteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeclineInviteMutationResult = NonNullable<Awaited<ReturnType<typeof declineInvite>>>

    export type DeclineInviteMutationError = unknown

    /**
 * @summary Decline an organization invite
 */
export const useDeclineInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineInvite>>, TError,{inviteId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof declineInvite>>,
        TError,
        {inviteId: string},
        TContext
      > => {
      return useMutation(getDeclineInviteMutationOptions(options));
    }
    /**
 * @summary Get invite landing details
 */
export const getInviteLanding = (
    token: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GetInviteLanding200>(
      {url: `/invites/${encodeURIComponent(String(token))}`, method: 'GET', signal
    },
      options);
    }




export const getGetInviteLandingQueryKey = (token: string,) => {
    return [
    `/invites/${token}`
    ] as const;
    }


export const getGetInviteLandingQueryOptions = <TData = Awaited<ReturnType<typeof getInviteLanding>>, TError = unknown>(token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInviteLanding>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInviteLandingQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInviteLanding>>> = ({ signal }) => getInviteLanding(token, requestOptions, signal);





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInviteLanding>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInviteLandingQueryResult = NonNullable<Awaited<ReturnType<typeof getInviteLanding>>>
export type GetInviteLandingQueryError = unknown


/**
 * @summary Get invite landing details
 */

export function useGetInviteLanding<TData = Awaited<ReturnType<typeof getInviteLanding>>, TError = unknown>(
 token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInviteLanding>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInviteLandingQueryOptions(token,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Accept pending organization invites
 */
export const acceptPendingInvites = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AcceptPendingInvites200>(
      {url: `/invites/accept-pending`, method: 'POST', signal
    },
      options);
    }




export const getAcceptPendingInvitesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptPendingInvites>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptPendingInvites>>, TError,void, TContext> => {

const mutationKey = ['acceptPendingInvites'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptPendingInvites>>, void> = () => {


          return  acceptPendingInvites(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptPendingInvitesMutationResult = NonNullable<Awaited<ReturnType<typeof acceptPendingInvites>>>

    export type AcceptPendingInvitesMutationError = unknown

    /**
 * @summary Accept pending organization invites
 */
export const useAcceptPendingInvites = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptPendingInvites>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof acceptPendingInvites>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAcceptPendingInvitesMutationOptions(options));
    }
    /**
 * @summary List pending organization invites
 */
export const listPendingInvites = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListPendingInvites200>(
      {url: `/invites/pending`, method: 'GET', signal
    },
      options);
    }




export const getListPendingInvitesQueryKey = () => {
    return [
    `/invites/pending`
    ] as const;
    }


export const getListPendingInvitesQueryOptions = <TData = Awaited<ReturnType<typeof listPendingInvites>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPendingInvites>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPendingInvitesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPendingInvites>>> = ({ signal }) => listPendingInvites(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPendingInvites>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPendingInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof listPendingInvites>>>
export type ListPendingInvitesQueryError = unknown


/**
 * @summary List pending organization invites
 */

export function useListPendingInvites<TData = Awaited<ReturnType<typeof listPendingInvites>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPendingInvites>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPendingInvitesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






